import { get, isNil } from 'lodash';

const getObject = (path, root) => {
  const found = get(root, path);
  return isNil(found) ? {} : found;
};

// noinspection JSUnusedGlobalSymbols
export default getObject;
